import React from 'react';
import { Modal, ModalContent, ModalHeader, ModalFooter, RegularButton } from 'fronton-react';
import { DocumentsList } from '../documents-list/documents-list';
import { ContentProps } from '../../types';
import { ErrorState } from '../error-state/error-state';
import { LoadingState } from '../loading-state/loading-state';
import { useTranslation } from 'react-i18next';

export const CERTIFICATE_RETRY_BUTTON_DATA_QA = 'certificate-retry-button';
export const CERTIFICATE_CLOSE_BUTTON_DATA_QA = 'certificate-close-button';

export const MobileModal = ({
  show,
  manuals,
  certificates,
  additionalText,
  isError,
  isLoading,
  onClose,
  onRetry,
}: ContentProps) => {
  const hasRenderContent = !isError && !isLoading;
  const { t } = useTranslation();

  return (
    <Modal show={show} onClose={onClose} size="s" variant="curtain">
      <ModalHeader title="Документы на товар" />

      <ModalContent>
        {isError && <ErrorState />}
        {isLoading && <LoadingState />}
        {hasRenderContent && (
          <DocumentsList manuals={manuals} certificates={certificates} additionalText={additionalText} />
        )}
      </ModalContent>

      <ModalFooter>
        {isError ? (
          <RegularButton
            data-qa={CERTIFICATE_RETRY_BUTTON_DATA_QA}
            onClick={onRetry}
            size="l"
            variant="primary"
          >
            {t('product-info.manuals.error-state.retry-button')}
          </RegularButton>
        ) : (
          <RegularButton
            data-qa={CERTIFICATE_CLOSE_BUTTON_DATA_QA}
            onClick={onClose}
            size="l"
            variant="secondary"
          >
            {t('product-info.manuals.close')}
          </RegularButton>
        )}
      </ModalFooter>
    </Modal>
  );
};
